class CollectionFilter extends HTMLElement {
  constructor() {
    super();
    // Drawer-related elements
    this.filtersDrawer = null;
    this.filtersOverlay = null;
    this.filtersTriggerButtons = null;
    this.filtersCloseButton = null;
    this.applyFiltersButton = null;
    this.clearFiltersButton = null;

    // Container for product grid & pagination
    this.productGridContainer = null;
    this.paginationContainer = null;
    this.loaderContainer = null;

    // For collapsibles
    this.collapsibleHeaders = null;

    // For sorting & checkboxes
    this.sortRadios = null;
    this.filterCheckboxes = null;

    // For view toggles
    this.view4Btn = null;
    this.view8Btn = null;
    this.currentViewMode = '4-per-row';

    // This is just a helper to confirm we want to watch for 'shopify' facets
    // or any advanced param naming logic
    this.shopifyFacetPrefix = 'filter.';
      this.applyColorSwatches();

  }

  connectedCallback() {
    // Called each time this element is inserted into the DOM.
    this.setupElements();
    this.bindEvents();
  }

  disconnectedCallback() {
    // Called each time the element is removed from the DOM.
    // Good place to remove event listeners if needed.
  }

  setupElements() {
    // Drawer
    this.filtersDrawer = document.querySelector('.js-filters-drawer');
    this.filtersOverlay = document.querySelector('.js-filters-overlay');
    this.filtersTriggerButtons = document.querySelectorAll('.js-filters-trigger');
    this.filtersCloseButton = document.querySelector('.js-filters-close');
    this.applyFiltersButton = document.querySelector('.js-apply-filters');
    this.clearFiltersButton = document.querySelector('.js-filter-clear');

    // Product grid & pagination
    this.productGridContainer = document.getElementById('ProductGridContainer');
    this.paginationContainer = document.getElementById('PaginationContainer');
    this.loaderContainer = document.querySelector('.loader-container');

    // Collapsibles
    this.collapsibleHeaders = document.querySelectorAll('.collapsible-header');

    // Sort & Filter checkboxes
    this.sortRadios = document.querySelectorAll('.sort-option');
    this.filterCheckboxes = document.querySelectorAll('.js-filter');

    // View toggles
    this.view4Btn = document.getElementById('view-4-btn');
    this.view8Btn = document.getElementById('view-8-btn');
  }

  bindEvents() {
    // Collapsible toggles
    this.collapsibleHeaders.forEach((header) => {
      header.addEventListener('click', () => {
        const icon = header.querySelector('.collapsible-icon');
        header.classList.toggle('active');

        const content = header.nextElementSibling;
        const isCollapsed = content.classList.toggle('collapsed');
        icon.textContent = isCollapsed ? '+' : '-';
        header.setAttribute('aria-expanded', !isCollapsed);
      });
    });

    // Drawer open/close
    this.filtersTriggerButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.toggleFiltersDrawer();
      });
    });
    if (this.filtersCloseButton) {
      this.filtersCloseButton.addEventListener('click', () => this.closeFiltersDrawer());
    }
    if (this.filtersOverlay) {
      this.filtersOverlay.addEventListener('click', () => this.closeFiltersDrawer());
    }
    if (this.applyFiltersButton) {
      this.applyFiltersButton.addEventListener('click', () => this.closeFiltersDrawer());
    }

    // Clear all filters
    if (this.clearFiltersButton) {
      this.clearFiltersButton.addEventListener('click', () => this.clearAllFilters());
    }

    // Sort changed
    this.sortRadios.forEach((radio) => {
      radio.addEventListener('change', (event) => {
        this.onSortChange(event);
      });
    });

    // Filter changed
    this.filterCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', (event) => {
        this.onFilterChange(event);
      });
    });

    // Pagination: intercept clicks
    if (this.paginationContainer) {
      this.paginationContainer.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (link) {
          const url = new URL(link.href);
          if (url.host === window.location.host) {
            e.preventDefault();
            history.replaceState({}, '', url.toString());
            this.fetchAndRender(url.toString()).then(() => {
              this.filterCheckboxes = document.querySelectorAll('.js-filter');
            });
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }
      });
    }

    // View toggles
    if (this.view4Btn) {
      this.view4Btn.addEventListener('click', () => {
        this.setViewMode('4-per-row');
      });
    }
    if (this.view8Btn) {
      this.view8Btn.addEventListener('click', () => {
        this.setViewMode('8-per-row');
      });
    }
  }

  // Drawer logic
  toggleFiltersDrawer() {
    this.filtersDrawer.classList.toggle('is-active');
    this.filtersOverlay.classList.toggle('is-active');
    document.body.classList.toggle('mobile-filters-open');
  }
  closeFiltersDrawer() {
    this.filtersDrawer.classList.remove('is-active');
    this.filtersOverlay.classList.remove('is-active');
    document.body.classList.remove('mobile-filters-open');
  }

  // Clear filters
  clearAllFilters() {
    const url = new URL(window.location.href);
    // remove all filter.* and sort_by/page params
    [...url.searchParams.keys()].forEach((param) => {
      if (
        param.startsWith(this.shopifyFacetPrefix) ||
        param === 'sort_by' ||
        param === 'page'
      ) {
        url.searchParams.delete(param);
      }
    });

    this.filterCheckboxes.forEach((checkbox) => {
       checkbox.checked = false;
     });
    // Update address bar
    history.replaceState({}, '', url.toString());
    // Reload via AJAX
    this.fetchAndRender(url.toString()).then(() => {
              this.filterCheckboxes = document.querySelectorAll('.js-filter');
            });
    this.closeFiltersDrawer();
  }

  // Sort logic
  onSortChange(event) {
    const selectedValue = event.target.value;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', selectedValue);
    url.searchParams.delete('page'); // reset to page 1
    history.replaceState({}, '', url.toString());
    this.fetchAndRender(url.toString()).then(() => {
              this.filterCheckboxes = document.querySelectorAll('.js-filter');
            });
  }

  // Facet logic
  onFilterChange(event) {
    const checkbox = event.target;
    const isChecked = checkbox.checked;
    const facetType = checkbox.dataset.facetType;  // e.g. "shopify"
    const filterParam = checkbox.dataset.filterParam;  // e.g. "filter.v.m.lobstter.color"
    const filterValue = checkbox.dataset.filterValue;  // e.g. "green"

    const url = new URL(window.location.href);
    url.searchParams.delete('page'); // always reset to page 1

    if (facetType === 'shopify') {
      // param might be exactly "filter.v.m.lobstter.color" from your data-filter-param
      // so we just append or remove it from the array
      const existingValues = url.searchParams.getAll(filterParam);

      if (isChecked) {
        if (!existingValues.includes(filterValue)) {
          url.searchParams.append(filterParam, filterValue);
        }
      } else {
        // remove it
        const filtered = existingValues.filter(val => val !== filterValue);
        url.searchParams.delete(filterParam);
        filtered.forEach(val => {
          url.searchParams.append(filterParam, val);
        });
      }
    }
    // If you had tag-based logic, you'd handle it differently here.

    history.replaceState({}, '', url.toString());
    this.fetchAndRender(url.toString()).then(() => {
              this.filterCheckboxes = document.querySelectorAll('.js-filter');
            });
  }

  // Switch between 4-per-row or 8-per-row, etc.
  setViewMode(mode) {
    this.currentViewMode = mode;
    const view4Btn = document.getElementById('view-4-btn');
    const view8Btn = document.getElementById('view-8-btn');

    // Toggle button UI
    view4Btn.classList.toggle('active', mode === '4-per-row');
    view8Btn.classList.toggle('active', mode === '8-per-row');

    // If your product container is a single element (like #ProductGridContainer),
    // you can toggle classes. If you have separate #view-4 / #view-8 divs, you can show/hide them as you prefer.
    // Example below is if you had a single container:
    /*
    this.productGridContainer.classList.remove('view-4', 'view-8');
    if (mode === '4-per-row') {
      this.productGridContainer.classList.add('view-4');
    } else {
      this.productGridContainer.classList.add('view-8');
    }
    */

    // If you have separate <div> for view-4, view-8, etc., then do:
    const view4El = document.getElementById('view-4');
    const view8El = document.getElementById('view-8');
    const view9El = document.getElementById('view-9'); // mobile fallback

    if (mode === '4-per-row') {
      view4El.style.display = 'block';
      view8El.style.display = 'none';
      view9El && (view9El.style.display = 'none');
    } else {
      // For 8
      // if screen width <= 1023 => show #view-9, else #view-8
      if (window.innerWidth <= 1023) {
        view4El.style.display = 'none';
        view8El.style.display = 'none';
        view9El && (view9El.style.display = 'block');
      } else {
        view4El.style.display = 'none';
        view8El.style.display = 'block';
        view9El && (view9El.style.display = 'none');
      }
    }
  }

  // Show/hide loader, then fetch partial
  async fetchAndRender(url) {
    this.showLoader(true);
    const ajaxUrl = new URL(url);
    // You can specify the view param to fetch partial if you like:
    ajaxUrl.searchParams.set('view', 'collection-grid');  // or 'your-custom-view'

    try {
      const response = await fetch(ajaxUrl.toString(), {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      const html = await response.text();

      // parse HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Replace product grid
      const newGrid = doc.getElementById('ProductGridContainer');
      if (newGrid && this.productGridContainer) {
        this.productGridContainer.innerHTML = newGrid.innerHTML;
      }

      // Replace pagination
      const newPagination = doc.getElementById('PaginationContainer');
      if (newPagination && this.paginationContainer) {
        this.paginationContainer.innerHTML = newPagination.innerHTML;
      }
      this.applyColorSwatches();

      this.showLoader(false);
    } catch (err) {
      console.error(err);
      this.showLoader(false);
    }
  }
  applyColorSwatches() {
    // 1. Grab all swatch elements
    const swatches = document.querySelectorAll('.color-checkbox__swatch');

    swatches.forEach((swatchEl) => {
      // 2. Read the color string from data-color
      let rawColorKey = swatchEl.getAttribute('data-color') || '';
      // For safety, unify the case or remove "color_" prefix, etc.
      rawColorKey = rawColorKey.toLowerCase().trim();

      // 3. Look up in window.Lobst.colors
      let colorValue = window.Lobst?.colors?.[rawColorKey];
      // If not found, fallback
      if (!colorValue) {
        colorValue = rawColorKey; // fallback color
      }

      // 4. If it's a gradient vs. hex
      if (typeof colorValue === 'string' && colorValue.startsWith('linear-gradient')) {
        swatchEl.style.backgroundImage = colorValue;
        swatchEl.style.backgroundColor = 'transparent';
      } else {
        // assume a hex or named color
        swatchEl.style.backgroundImage = 'none';
        swatchEl.style.backgroundColor = colorValue;
      }
    });
  }


  showLoader(show) {
    if (!this.loaderContainer) return;
    this.loaderContainer.style.display = show ? 'block' : 'none';
  }
}

// Define your custom element
customElements.define('collection-filter', CollectionFilter);
